import * as ActionTypes from '../../actions/allActions'
import { affiliateMessageNormalizer } from '../../normalizers/Normalizers'

const affiliateMessagesInit = []
const affiliateMessages = (state = affiliateMessagesInit, action) => {
	switch(action.type){
		case ActionTypes.FETCHAFFILIATEMESSAGES_SUCCESS:
			return action.data.data.map(message => affiliateMessageNormalizer(message))
		case ActionTypes.SUBMITAFFILIATEMESSAGE_SUCCESS:
			return [ ...state, affiliateMessageNormalizer(action.data.data) ]
		case ActionTypes.LOGOUT:
			return affiliateMessagesInit
		default:
			return state
	}
}

export default affiliateMessages



// WEBPACK FOOTER //
// ./src/reducers/data/affiliateMessages.js